import {CheckoutSSMockApi} from "src/app/mock-api/features/ss/api";
import {FidelityMockApi} from "../../mock-api/features/fidelity/api";
import {NutritionalMockApi} from "../../mock-api/features/nutritional/api";
import {CouponsMockApi} from "../../mock-api/features/coupons/api";

export * from './mock-api.constants';
export * from './mock-api.module';
export * from './mock-api.service';
export * from './mock-api.types';
export * from './mock-api.utils';

export const mockApiServices = [
  //MenuMockApi,
  //ArticleMockApi,
  CheckoutSSMockApi,
  //ConfigMockApi,
  NutritionalMockApi,
  FidelityMockApi,
  CouponsMockApi
];

